import foto_desarrollo from '../img/carreras_desarrollo.png';
import foto_administracion from '../img/carreras_empresas.png';
import foto_bromatologia from '../img/carreras_bromatologia.png';
import foto_energias from '../img/carreras_energias.png';
import foto_contable from '../img/carreras_contable.png';
import foto_ia from '../img/desarrollo_ia.png';
import foto_digital from '../img/gestion_digital.png';
import foto_at from '../img/acompa.png';
import foto_turismo from '../img/turismo.png';

// Mapea el "slug" de cada carrera (carreras.json) con su imagen.
// TODO: reemplazar estos 3 placeholders por fotos propias cuando estén listas.
const imagenesCarreras = {
    carrera_desarrollo: foto_desarrollo,
    carrera_desarrollo_ia: foto_ia,
    carrera_administracion: foto_administracion,
    carrera_contable: foto_contable,
    carrera_bromatologia: foto_bromatologia,
    carrera_energias: foto_energias,
    carrera_turismo: foto_turismo,          // placeholder
    carrera_gestion_digital: foto_digital,       // placeholder
    carrera_acompanante_terapeutico: foto_at, // placeholder
};

export default imagenesCarreras;